import { useId } from 'react'
import { CATEGORY_PALETTE, categoryVisual } from '@core/utils/categoryVisual'
import { CategoryIcon } from './CategoryIcon'

export interface CategoryGlyphProps {
  /** Имя категории: из него выводятся градиент и предметная иконка. */
  name: string
  /** Размер в px (квадрат). */
  size?: number
  /** Ручной override цвета (индекс палитры). */
  colorKey?: number | null
  /** Устаревший override глифа: оставлен для совместимости вызовов. */
  glyph?: number | null
  className?: string
  /** Скругление фона: доля от размера (0.25 = 25%). */
  rounded?: number
}

/**
 * Векторный визуал категории: градиент + белая предметная иконка по названию
 * (молоко, сосиски, консервы и т.д.). Детерминирован по имени, не требует
 * сети и файлов; загруженная картинка категории имеет приоритет и рисуется
 * выше — в `CategoryImage`.
 */
export function CategoryGlyph({
  name,
  size = 40,
  colorKey,
  glyph,
  className,
  rounded = 0.25
}: CategoryGlyphProps) {
  const rawId = useId()
  const gradientId = `cg-${rawId.replace(/[^a-zA-Z0-9_-]/g, '')}`
  const visual = categoryVisual(name, colorKey, glyph)
  const gradient = CATEGORY_PALETTE[visual.colorKey]

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={gradient.from} />
          <stop offset="100%" stopColor={gradient.to} />
        </linearGradient>
      </defs>
      <rect
        width="96"
        height="96"
        rx={96 * rounded}
        fill={`url(#${gradientId})`}
      />
      <g
        opacity="0.96"
        style={{ filter: 'drop-shadow(0 1px 1.5px rgba(15,23,42,0.28))' }}
      >
        <CategoryIcon name={name} />
      </g>
    </svg>
  )
}
